import { ControlAndSettingsIcon } from '../../../components/SVGComponents/ControlAndSettingsIcon';
import FindingDropIcon from '../../../components/SVGComponents/FindingDropIcon';
import CustomReportTemplateIcon from '../../../components/SVGComponents/CustomReportTemplateIcon';
import { YourReportsIcon } from '../../../components/SVGComponents/YourReportsIcon';
import { DefaultButton, Dropdown, PrimaryButton, TooltipHost } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { SELECTED_TAB_KEY } from '../../../constants/Constants';
import { t } from 'i18next';
import Moment from 'moment';
import CustomToolTipHost from '../../../components/CustomToolTipHost/CustomToolTipHost';

export const breadCrumbItems = [
  {
    text: 'Issues & troubleshooting',
    key: 'masters',
  },
];

export const tabDetails = (selectedValue) => {
  return [
    {
      id: SELECTED_TAB_KEY.TROUBLESHOOTING + '1',
      title: t('navbar.audit-log'),
      contentClass: 'tabContent',
      icon: (
        <CustomReportTemplateIcon
          active={selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '1'}
        />
      ),
    },
    {
      id: SELECTED_TAB_KEY.TROUBLESHOOTING + '2',
      title: t('error-study-list.error-logs'),
      contentClass: 'tabContent',
      icon: (
        <ControlAndSettingsIcon
          active={selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '2'}
        />
      ),
    },
    {
      id: SELECTED_TAB_KEY.TROUBLESHOOTING + '3',
      title: t('error-code-list.error-codes'),
      contentClass: 'tabContent',
      icon: (
        <YourReportsIcon
          active={selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '3'}
        />
      ),
    },
    {
      id: SELECTED_TAB_KEY.TROUBLESHOOTING + '4',
      title: t('error-code-list.ai-orchestrator'),
      contentClass: 'tabContent',
      icon: (
        <FindingDropIcon
          active={selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '4'}
        />
      ),
    },
    {
      id: SELECTED_TAB_KEY.TROUBLESHOOTING + '5',
      title: t('error-code-list.issue-tracker'),
      contentClass: 'tabContent',
      icon: (
        <FindingDropIcon
          active={selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '5'}
        />
      ),
    },
  ];
};

export const tabDetailsFirmTechnician = (selectedValue) => {
  return [
    {
      id: SELECTED_TAB_KEY.TROUBLESHOOTING + '1',
      title: t('error-study-list.error-logs'),
      contentClass: 'tabContent',
      icon: (
        <ControlAndSettingsIcon
          active={selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '1'}
        />
      ),
    },
    {
      id: SELECTED_TAB_KEY.TROUBLESHOOTING + '2',
      itle: t('error-code-list.error-codes'),
      contentClass: 'tabContent',
      icon: (
        <YourReportsIcon
          active={selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '2'}
        />
      ),
    },
  ];
};

const getConsistentDateFormat = (date) => {
  if (Moment(date).isValid()) {
    return Moment(date).format('DD-MMM-YY hh:mm A');
  } else {
    return 'No Date';
  }
};

export const TroubleShootingAuditColumns = (type) => {
  let widthStyle = 'calc((100vw - 200px) / 8)';
  let paddingChild = '15px 0px 15px 10px';
  return [
    {
      id: 'id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('audit-logs.id')}</>,
      accessor: 'clients',
      accessorKey: 'clients',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">{info.row.original.id}</div>
        </>
      ),
    },
    {
      id: 'action',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('audit-logs.action')}</span>,
      accessor: 'action',
      accessorKey: 'action',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            <CustomToolTipHost
              content={info.row.original.action}
              id={'tooltip_'}
            >
              <span
                style={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  width: '170px',
                  display: 'block',
                }}
              >
                {info.row.original.action}
              </span>
            </CustomToolTipHost>
          </div>
        </>
      ),
    },
    {
      id: 'audit-time-stamp',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => (
        <span className="">{t('audit-logs.audit-time-stamp')}</span>
      ),
      accessor: 'audit-time-stamp',
      accessorKey: 'audit-time-stamp',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {getConsistentDateFormat(info.row.original.auditTimestamp)}
          </div>
        </>
      ),
    },
    {
      id: 'new-value',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('audit-logs.new-value')}</span>,
      accessor: 'new-value',
      accessorKey: 'audit-time-stamp',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {info.row.original.newValue == ''
              ? '-'
              : info.row.original.newValue}
          </div>
        </>
      ),
    },
    {
      id: 'old-value',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('audit-logs.old-value')}</span>,
      accessor: 'old-value',
      accessorKey: 'old-value',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {info.row.original.oldValue == ''
              ? '-'
              : info.row.original.oldValue}
          </div>
        </>
      ),
    },
    {
      id: 'entitiy-id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('audit-logs.entity-id')}</span>,
      accessor: 'entitiy-id',
      accessorKey: 'entitiy-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {!info.row.original.entityId || info.row.original.entityId == ''
              ? '-'
              : info.row.original.entityId}
          </div>
        </>
      ),
    },
    {
      id: 'username',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('audit-logs.username')}</span>,
      accessor: 'username',
      accessorKey: 'username',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">{info.row.original.username}</div>
        </>
      ),
    },
    {
      id: 'remote-ip',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('audit-logs.ip')}</span>,
      accessor: 'remote-ip',
      accessorKey: 'remote-ip',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {info.row.original.remoteIPAddress}
          </div>
        </>
      ),
    },
  ];
};

export const IssueTrackerListColumns = (type, updateAction) => {
  let widthStyle = 'calc((100vw - 230px) / 11)';
  let paddingChild = '15px 0px 15px 10px';

  const status_code_map = {
    1: 'Success',
    2: 'Failed',
    3: 'Warning',
   
  };

  const rowsPerPage = [
    // {
    //   key : "SUCCESS", 
    //   text : "Success"
    // }, 
    {
      key: 'FAILED',
      text: "Failed",
    },
    {
      key: "WARNING",
      text: "Warning",
    }
  ];
  return [
    {
      id: 'id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('issue-tracker-logs.id')}</>,
      accessor: 'clients',
      accessorKey: 'clients',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">{info.row.original.id}</div>
        </>
      ),
    },
    {
      id: 'patient-id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
       
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => (
        <span className="">{t('issue-tracker-logs.patient-id')}</span>
      ),
      accessor: 'action',
      accessorKey: 'action',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
          <CustomToolTipHost
              content={info.row.original.patientId}
              id={'tooltip_'}
            >
              <span
                style={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  width: '120px',
                  display: 'block',
                }}
              >
                {info.row.original.patientId}
              </span>
            </CustomToolTipHost>
          </div>
        </>
      ),
    },
    {
      id: 'issue-tracker-time-stamp',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => (
        <span className="">
          {t('issue-tracker-logs.issue-tracker-time-stamp')}
        </span>
      ),
      accessor: 'audit-time-stamp',
      accessorKey: 'audit-time-stamp',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {getConsistentDateFormat(info.row.original.issueStatusTimestamp)}
          </div>
        </>
      ),
    },
    {
      id: 'study-id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('issue-tracker-logs.study-id')}</span>,
      accessor: 'new-value',
      accessorKey: 'issue-tracker-study-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {info.row.original.studyId == '' ? '-' : info.row.original.studyId}
          </div>
        </>
      ),
    },
    {
      id: 'order-id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('issue-tracker-logs.order-id')}</span>,
      accessor: 'old-value',
      accessorKey: 'old-value',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {!info.row.original.orderId || info.row.original.orderId == '' ? '-' : info.row.original.orderId}
          </div>
        </>
      ),
    },
    {
      id: 'accession-number',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('issue-tracker-logs.accession-number')}</span>,
      accessor: 'old-value',
      accessorKey: 'old-value',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            <CustomToolTipHost
              content= {info.row.original.accessionNumber == '' ? '-' : info.row.original.accessionNumber}
              id={'tooltip_'}
            >
              <span
                style={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  width: '120px',
                  display: 'block',
                }}
              >
               {!info.row.original.accessionNumber || info.row.original.accessionNumber == '' ? '-' : info.row.original.accessionNumber}
              </span>
            </CustomToolTipHost>
          </div>
        </>
      ),
    },
    {
      id: 'status',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('issue-tracker-logs.status')}</span>,
      accessor: 'entitiy-id',
      accessorKey: 'entitiy-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {!info.row.original.status || info.row.original.status == ''
              ? '-'
              : info.row.original.status}
          </div>
        </>
      ),
    },
    // {
    //   id: 'retry-count',
    //   style: { width: widthStyle },
    //   headerStyle: {
    //     padding: paddingChild,
    //     textAlign: 'centre',
    //     boxSizing: 'border-box',
    //     width: widthStyle,
    //   },
    //   headerClass: 'break-word',
    //   classChildName: 'break-word',
    //   header: () => <span className="">{t('issue-tracker-logs.retry-count')}</span>,
    //   accessor: 'entitiy-id',
    //   accessorKey: 'entitiy-id',
    //   show: true,
    //   cell: (info) => (
    //     <>
    //       <div className="user-sub-heading">
    //         {!info.row.original.retryCount || info.row.original.retryCount == ''
    //           ? '-'
    //           : info.row.original.retryCount}
    //       </div>
    //     </>
    //   ),
    // },
    {
      id: 'work-flow-name',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('issue-tracker-logs.work-flow-name')}</span>,
      accessor: 'entitiy-id',
      accessorKey: 'entitiy-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {!info.row.original.workFlowName || info.row.original.workFlowName == ''
              ? '-'
              : info.row.original.workFlowName}
          </div>
        </>
      ),
    },
    {
      id: 'issue-tracker-last-run',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => (
        <span className="">
          {t('issue-tracker-logs.issue-tracker-last-run')}
        </span>
      ),
      accessor: 'audit-time-stamp',
      accessorKey: 'audit-time-stamp',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {getConsistentDateFormat(info.row.original.lastRunTime)}
          </div>
        </>
      ),
    },
    {
      id: 'response-message',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('issue-tracker-logs.response-message')}</span>,
      accessor: 'entitiy-id',
      accessorKey: 'entitiy-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {!info.row.original.response || info.row.original.response == ''
              ? '-'
              : info.row.original.response }
          </div>
        </>
      ),
    },
    {
      id: 'action',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('issue-tracker-logs.action')}</span>,
      accessor: 'entitiy-id',
      accessorKey: 'entitiy-id',
      show: true,
      cell: (info) => (
        <>
          <Dropdown
            defaultSelectedKey={info.row.original.status}
            options={rowsPerPage}
            onChange={(e, selected) => {
              console.log("handle drop down", selected);
              updateAction(selected.key, info.row.original.id);
            }}
          />
        </>
      ),
    },
  ];
};

export const TroubleShootingOrchestratorColumns = (type, orchestratorUrl) => {
  let widthStyle = 'calc((100vw - 200px) / 6)';
  let paddingChild = '15px 0px 15px 10px';
  const orchestrator_url = orchestratorUrl; //Add env variable
  const status_code_map = {
    1: 'In Progress',
    2: 'Thumbnail Successful, Inference In Progress',
    3: 'Thumbnail Successful, Not Sent For Inference',
    4: 'Inference Successful, Post Processing In Progress',
    5: 'Inference Successful, Post Processing Completed',
    6: 'Thumbnail Failed',
    7: 'Inference Failed',
    8: 'Inference Post Processing Failed',
  };
  return [
    {
      id: 'id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('orchestrator-logs.id')}</>,
      accessor: 'clients',
      accessorKey: 'clients',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">{info.row.original.id}</div>
        </>
      ),
    },
    {
      id: 'patient-id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        paddingLeft: '20px',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => (
        <span className="">{t('orchestrator-logs.patient-id')}</span>
      ),
      accessor: 'action',
      accessorKey: 'action',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            <CustomToolTipHost
              content={info.row.original.patientId}
              id={'tooltip_'}
            >
              <span
                style={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  width: '170px',
                  display: 'block',
                }}
              >
                {info.row.original.patientId}
              </span>
            </CustomToolTipHost>
          </div>
        </>
      ),
    },
    {
      id: 'orchestrator-time-stamp',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => (
        <span className="">
          {t('orchestrator-logs.orchestrator-time-stamp')}
        </span>
      ),
      accessor: 'audit-time-stamp',
      accessorKey: 'audit-time-stamp',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {getConsistentDateFormat(info.row.original.orchestratorTimestamp)}
          </div>
        </>
      ),
    },
    {
      id: 'study-id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('orchestrator-logs.study-id')}</span>,
      accessor: 'new-value',
      accessorKey: 'orchestrator-study-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {info.row.original.studyId == '' ? '-' : info.row.original.studyId}
          </div>
        </>
      ),
    },
    {
      id: 'job-id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('orchestrator-logs.job-id')}</span>,
      accessor: 'old-value',
      accessorKey: 'old-value',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            <a
              href={`${orchestrator_url}/execution/${info.row.original.jobId}`}
              target="_blank"
              style={{ color: '#337ab7', textDecoration: 'none' }}
            >
              {info.row.original.jobId == '' ? '-' : info.row.original.jobId}
            </a>
          </div>
        </>
      ),
    },
    {
      id: 'status',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'centre',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="">{t('orchestrator-logs.status')}</span>,
      accessor: 'entitiy-id',
      accessorKey: 'entitiy-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {!info.row.original.status || info.row.original.status == ''
              ? '-'
              : status_code_map[info.row.original.status]}
          </div>
        </>
      ),
    },
  ];
};

const customToolTipErrDesc = {
  root: 'error-discription-text',
};

export const TroubleShootingStudyErrorColumns = (type) => {
  let widthStyle = 'calc((100vw - 200px) / 7)';
  let paddingChild = '15px 0px 15px 10px';
  return [
    {
      id: 'id',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('error-study-list.patient-id')}</>,
      accessor: 'patient-id',
      accessorKey: 'patient-id',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">{info.row.original.patientId}</div>
        </>
      ),
    },
    {
      id: 'error-code',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('error-study-list.error-code')}</>,
      accessor: 'hospital-code',
      accessorKey: 'hospital-code',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {info.row.original.hospitalCode}
          </div>
        </>
      ),
    },
    {
      id: 'hospital-code',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('error-study-list.hospital-code')}</>,
      accessor: 'error-code',
      accessorKey: 'error-code',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">{info.row.original.errorCode}</div>
        </>
      ),
    },

    {
      id: 'object-path',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('error-study-list.object-path')}</>,
      accessor: 'object-path',
      accessorKey: 'object-path',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {info.row.original.objectName == ''
              ? '-'
              : info.row.original.objectName}
          </div>
        </>
      ),
    },
    {
      id: 'error-desc',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('error-study-list.description')}</>,
      accessor: 'error-desc',
      accessorKey: 'error-desc',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            <CustomToolTipHost
              styles={customToolTipErrDesc}
              content={info.row.original.errorDescription}
              id="error-des"
            >
              {!info.row.original.errorDescription ||
              info.row.original.errorDescription == ''
                ? '-'
                : info.row.original.errorDescription}
            </CustomToolTipHost>
          </div>
        </>
      ),
    },
    {
      id: 'action-by',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('error-study-list.action')}</>,
      accessor: 'action-by',
      accessorKey: 'action-by',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            <CustomToolTipHost
              styles={customToolTipErrDesc}
              content={info.row.original.actionBy}
              id="error-des"
            >
              {info.row.original.actionBy == ''
                ? '-'
                : info.row.original.actionBy}
            </CustomToolTipHost>
          </div>
        </>
      ),
    },
    {
      id: 'error-date',
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <>{t('error-study-list.error-date')}</>,
      accessor: 'error-date',
      accessorKey: 'error-date',
      show: true,
      cell: (info) => (
        <>
          <div className="user-sub-heading">
            {getConsistentDateFormat(info.row.original.createdDate)}
          </div>
        </>
      ),
    },
  ];
};

export const TroubleShootingStudyCodeColumns = (type) => {
  const { t } = useTranslation();
  return [
    {
      id: 'username',
      style: { width: '30vw' },
      headerStyle: { padding: '15px 0px 15px 10px', textAlign: 'left' },
      headerClass: 'break-word column-user-details-header',
      classChildName: 'break-word cursor-pointer',
      header: () => <span className="">Details</span>,
      accessor: 'clients',
      accessorKey: 'clients',
      show: true,
      cell: (info) => (
        <>
          <div>
            <div style={{ display: 'flex' }}>
              <div className="user-heading">Error Code:&nbsp;</div>
              <div className="user-sub-heading">
                {info.row.original.errorCode}
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];
};

export const searchStyle = {
  root: {
    background: 'transparent',
    border: '1px solid rgba(200, 198, 196, 0.3)',
    borderRadius: '5px',
  },
};

export const auditInitialState = {
  userActionDropdownObj: null,
  userNameObj: null,
  entityIdObj: null,
  startDateObj: null,
  endDateObj: null,
};
export const orchestratorInitialState = {
  studyIdObj: null,
  patientIdObj: null,
  jobIdObj: null,
  startDateObj: null,
  endDateObj: null,
  status: null,
};

export const issueStatusFilterState = {
  studyIdObj :null,
  patientIdObj : null, 
  workFlowNameObj : null, 
  startDateObj : null,
  endDateObj : null, 
  statusObj : null

}

export const calendarStyle = {
  root: {
    color: '#A19F9D',
    background: "transparent"
  },
  goTodayButton: {
    color: '#A19F9D',
  },
  headerIconButton: {
    color: '#A19F9D',
  },
  daySelected: {
    background: '#5A5A5A',
  },
  dayIsToday: {
    background: 'red',
  },
  liveRegion: {
    color: '#A19F9D',
  },
  weekDayLabelCell: {
    paddingLeft: '2px',
  },
};

export const errorStudyInitialState = (date) => {
  return {
    dateFrom: date,
    dateTo: date,
  };
};

export const auditInitialStateFunc = (date)=>{
  return {
    userActionDropdownObj: null,
    userNameObj: null,
    entityIdObj: date,
    startDateObj: date,
    endDateObj: null,
  }
};

export const getLabelForDateAuditLog = (label,date) => {
  if(label != "startDateObj" && label != "endDateObj"){
    return date;
  }
  if(date == null)return null;
  else{
    if(label == "startDateObj"){
      return "From: "+date;
    }else{
      return "To: "+date;
    }
  }
}
